import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import {
  HireTeamDubaiIcon,
  HireDevDubaiIcon,
  HireRemDubaiIcon,
  HireOrangeDubaiIcon,
} from "../../../app-constants";
import BgImg from "../../images/locationgcc/hire-sa/engagement_models.webp";

function Hireengagementmodels() {
  return (
    <div
      className="hire_engagement_models p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={7} xl={7} xxl={7} className="">
            <h2>
              Our Efficient Models To Help You Hire Mobile App Developer In KSA
            </h2>
          </Col>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="">
            <p>
              Are you looking to hire mobile app developers in Saudi Arabia? We
              have formalized some productive methods to ensure the hiring of
              the right resource for your{" "}
              <Link to="https://www.tekrevol.com/sa/mobile-apps-development-in-saudi-arabia">
                app development
              </Link>{" "}
              project.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="engagement_box">
              <div className="engagement_img">{HireTeamDubaiIcon}</div>
              <div className="engagement_content">
                <h6>
                  Hire Top App
                  <br /> Development Team
                </h6>
                <p>
                  Get a top-tier app development team specifically assigned as
                  per your project needs.
                </p>
                <div className="engagement_btn">
                  <Link
                    to="/contact"
                    className=""
                    aria-label="TekRevol Contact"
                  >
                    Hire A Developer {HireOrangeDubaiIcon}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="engagement_box">
              <div className="engagement_img">{HireDevDubaiIcon}</div>
              <div className="engagement_content">
                <h6>
                  Hire Developers Onsite for
                  <br /> Contractual Basis
                </h6>
                <p>
                  Collaborate with skilled developers as per contract for short
                  or long-term projects.
                </p>
                <div className="engagement_btn">
                  <Link
                    to="/contact"
                    className=""
                    aria-label="TekRevol Contact"
                  >
                    Hire A Developer {HireOrangeDubaiIcon}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="engagement_box">
              <div className="engagement_img">{HireRemDubaiIcon}</div>
              <div className="engagement_content">
                <h6>
                  Hire Remote Developers On
                  <br /> Hourly Basis
                </h6>
                <p>
                  Scale resources as needed with experienced developers
                  available on an hourly basis.
                </p>
                <div className="engagement_btn">
                  <Link
                    to="/contact"
                    className=""
                    aria-label="TekRevol Contact"
                  >
                    Hire A Developer {HireOrangeDubaiIcon}
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Hireengagementmodels;
